<template>
  <div
    class="flex flex-col items-center justify-center border rounded bg-gray-100 p-4"
  >
    <div
      class="text-lg text-center text-th-secondary font-bold mb-2"
      data-testid="ai-chat-limit-title"
    >
      {{ t('aichat.main.limit.title') }}
    </div>
    <div
      class="text-sm text-center text-th-secondary-gray mb-4"
      data-testid="ai-chat-limit-description"
    >
      {{ t('aichat.main.limit.description') }}
    </div>
    <el-button type="primary" data-testid="ai-chat-limit-upgrade-button">
      {{ t('aichat.main.limit.button.upgrade') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
